import { getPlatforms } from "@ionic/react";
import PubSub from "pubsub-js";
import { Dispatch, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { pubsubEvents } from "../../../components/helpers/socket/pubsubEvent";

// import { isNull, isEmpty, clone } from 'underscore'
import { RouteProps } from "react-router-dom";
import { isEmpty } from "underscore";
import config from "../../../components/helpers/socket/config";
import { send } from "../../../utils/sockets/asyncSocket";
import MarketDataContainer from "./MarketDataContainer";
import { TradingGridGroupLiveView } from "./interfaces";
import { CapacitorPreferencesConstants } from "../../../components/Constants";
import {
  getCapacitorPreference,
  removeCapacitorPreference,
  setCapacitorPreference,
} from "../../../utils/core-utils/capPreferencesUtils";
import { OrdersDataType, OrdersType } from "../../../Constants";

type TradingGridGroup = {
  id: string;
  n: string;
};

type TradingGridData = {
  identifier: string;
  data: Data[];
};

type Data = {
  b: { r: number; f: string };
  bb: { r: number; f: string };
  bo: { r: number; f: string };
  boq: { r: number; f: string };
  c: string;
  i: boolean;
  id: string;
  ii: string;
  l: any;
  lt: number;
  n: any;
  s: number;
  t: any;
  ts: string;
  wo: number;
};

export type CMEDPermissions = {
  canKill: boolean;
  canHold: boolean;
  canAmend: boolean;
  canSubmit: boolean;
  warnWhenModifyingOrder: boolean;
  warnWhenSubmittingOrder: boolean;
  companyName: string;
  fullName: string;
  type: string;
  accountName: string;
  availableGreeksSources: string;
  defaultOrderHandling: number;
  showOrderHandling: boolean;
  showOnBehalfOf: boolean;
  agressiveOrderIndicator: boolean;
  showNotes: boolean;
};

interface MarketDataContentProps extends RouteProps {
  isCMEDLoggedIn: boolean;
  userCMEDEntitlements: CMEDPermissions | undefined;
  setSendRequest: Dispatch<any>;
  sendRequest: any[];
}

function MarketDataContent(props: any) {
  const isDesktopMode = getPlatforms().includes("desktop");

  const [tradingGridGroup, setTradingGridGroup] = useState<TradingGridGroup[]>(
    [],
  );
  const [tradingGridGroupLiveView, setTradingGridGroupLiveView] = useState<
    TradingGridGroupLiveView[]
  >([]);

  const [allContracts, setAllContracts] = useState();
  const [isSnapshot, setIsSnapshot] = useState(false);

  const [tradingGridGroupData, setTradingGridGroupData] = useState<
    TradingGridData[]
  >([]);

  const [isLoadingMarketData, setIsLoadingMarketData] = useState<boolean>(true);

  let subRequestForTradingGridGroups = {
    action: config.socket.actions.CMED_ORDERS_SUBSCRIBE,
    type: OrdersType.ORDERS_DATA_SUBSCRIBE,
    requestID: uuidv4(),
    payload: {
      ordersDataType: "TradingGridGroupsV2",
    },
  };
  let subRequestForTradingUserDetails = {
    action: config.socket.actions.CMED_ORDERS_SUBSCRIBE,
    type: OrdersType.ORDERS_DATA_SUBSCRIBE,
    requestID: uuidv4(),
    payload: {
      orderId: "",
      ordersDataType: OrdersDataType.TRADING_USER_DETAILS,
    },
  };

  useEffect(() => {
    //grid data - instrument inside arjo's basket
    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_TRADING_GRID_GROUP_ITEM_UPDATE,
      async (data, res) => {
        updateTradingGridGroupData(data, res);
      },
    );

    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ORDER_ENTRY_RESPONSE,
      (data) => {
        storeEntryCriteria(data);
      },
    );
    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_PRICE_TICKS_RESPONSE,
      (data) => {
        updateTicks(data);
      },
    );
    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_ORDER_ENTRY_REQUEST,
      (data) => {
        updateActiveModel(data);
      },
    );
    PubSub.subscribe(pubsubEvents.socketKeys.CMED_NEW_ORDER_SUCCESS, (data) => {
      onOrderSuccess(data);
    });
    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_AGGRESSION_ORDER_SUCCESS,
      (data) => {
        onAggressionOrderSuccess(data);
      },
    );
    PubSub.subscribe(
      pubsubEvents.socketKeys.CMED_CONTRACT_REMOVED_SUCCESS,
      (data) => {
        onContractRemoved(data);
      },
    );
  }, []);

  useEffect(() => {
    if (props.isCMEDLoggedIn) {
      setIsLoadingMarketData(true);
      send(config.socket.channels.TRADING, subRequestForTradingGridGroups);
      send(config.socket.channels.TRADING, subRequestForTradingUserDetails);
    }
  }, [props.isCMEDLoggedIn]);

  useEffect(() => {
    const getTradingGridLiveFlagPref = async () => {
      const tradingGridLiveDataPref = await getCapacitorPreference(
        CapacitorPreferencesConstants.TRADING_GRID_LIVE_PREF_FLAG,
      );
      if (tradingGridLiveDataPref != null) {
        setTradingGridGroupLiveView(JSON.parse(tradingGridLiveDataPref));
      }
    };
    getTradingGridLiveFlagPref();
  }, []);

  useEffect(() => {
    const setTradingGridLiveFlagPref = async () => {
      if (
        tradingGridGroupLiveView == null ||
        tradingGridGroupLiveView.length === 0
      ) {
        await removeCapacitorPreference(
          CapacitorPreferencesConstants.TRADING_GRID_LIVE_PREF_FLAG,
        );
        return;
      }
      const tradingGridLiveDataPrefStr = JSON.stringify(
        tradingGridGroupLiveView,
      );
      await setCapacitorPreference(
        CapacitorPreferencesConstants.TRADING_GRID_LIVE_PREF_FLAG,
        tradingGridLiveDataPrefStr,
      );
    };
    setTradingGridLiveFlagPref();
  }, [tradingGridGroupLiveView]);

  //code for unsub
  // useIonViewDidLeave(()=> {
  //   send(config.socket.channels.TRADING, unSubRequestForTradingGridGroups);
  //   send(config.socket.channels.TRADING, unSubRequestForTradingUserDetails);
  //   //todo
  //   //reset states
  // })

  // const updateTradingGridGroupData = (id :any, data:any) => {
  //     const updatedTradingGridGroupData = tradingGridGroupData.map((data:any) => {
  //         if(data?.id === )
  //     })
  // }

  /**
   * Uses the response to work out the action that should be performed
   * in the collection - `reset`, `add`, `update`. When ticking up on a bid/ofr
   * CMED will return the full payload each time, when ticking down they return only
   * the modified record.
   *
   * @param  {Object} response Server response containing full CMED order payload.
   * @return {undefined}
   */
  async function updateTradingGridGroupData(data: any, res: any) {
    const payload: Data[] = res.payload.data;
    const identifier: string = res.payload.identifier;

    setIsLoadingMarketData(false);

    if (isEmpty(res.payload.data) && isEmpty(res.payload.deletions)) return;

    if (res.payload.isSnapshot) {
      setIsSnapshot(res.payload.isSnapshot);
      const value = { identifier: identifier, data: payload };
      console.log(tradingGridGroupData);

      setTradingGridGroupData((prevObjects) => {
        const updatedObjects = [...prevObjects];

        const { identifier, data } = value;
        // Find the object with the matching identifier
        const objectIndex = updatedObjects.findIndex(
          (obj) => obj.identifier === identifier,
        );

        if (objectIndex !== -1) {
          // Object with matching identifier found, update the data
          //   const existingData = updatedObjects[objectIndex].data;

          //   if (updatedObjects[objectIndex].data.length < update.data.length) {
          //     // existingData = updates.data;
          let existData = [...prevObjects];
          existData[objectIndex].data = data;
          return existData;
          //   }
          //   for (const newData of data) {
          //     const { id } = newData;

          //     // Find the data object with the matching ID
          //     const dataIndex = existingData.findIndex(
          //       (item) => item["id"] === id
          //     );

          //     if (dataIndex !== -1) {
          //       // Data object with matching ID found, update the price
          //       existingData[dataIndex] = newData;
          //     }
          //   }
        } else {
          let newData = [...prevObjects, value];
          return newData;
        }

        // return updatedObjects
      });
    } else {
      console.log("updateTradingGridGroupData", payload);

      let arr: Data[] = [];
      res.payload.data.forEach((order: Data) => {
        arr.push(order);
      });
      if (res.payload.data.length) {
        const value = [{ identifier: identifier, data: arr }];

        handleUpdate(value);
      }

      //Note: effective only when we delete a contract
      if (res.payload.deletions.length === 1) {
        console.log("updateTradingGridGroupData DELETE", res.payload.deletions);

        const value = [
          { identifier: identifier, data: res.payload.deletions[0] },
        ];

        handleDelete(value);
      } else if (res.payload.deletions.length > 1) {
        if (res.payload.data.length > 0) {
          handleEditViewDelete([
            { identifier: identifier, data: res.payload.data },
          ]);
        } else {
          handleMultipleDelete([
            { identifier: identifier, data: res.payload.deletions },
          ]);
        }
      }
    }
  }
  // }

  const handleDelete = (updates: any[]) => {
    console.log("updateTradingGridGroupData handleDelete", updates);

    setTradingGridGroupData((prevObjects) => {
      const updatedObjects = [...prevObjects]; // Create a copy of the existing objects

      for (const update of updates) {
        const { identifier, data } = update;
        // Find the object with the matching identifier
        const objectIndex = updatedObjects.findIndex(
          (obj) => obj.identifier === identifier,
        );

        if (objectIndex !== -1) {
          // Object with matching identifier found, update the data

          const existingData = updatedObjects[objectIndex].data;

          // Find the data object with the matching ID
          const dataIndex = existingData.findIndex(
            (item) => item["id"] === data,
          );
          if (dataIndex !== -1) {
            // Data object with matching ID found, update the price
            existingData.splice(dataIndex, 1);
          }
        }
      }
      return updatedObjects;
    });
  };

  const handleEditViewDelete = (updates: TradingGridData[]) => {
    setTradingGridGroupData((prevObjects) => {
      const updatedObjects = [...prevObjects]; // Create a copy of the existing objects

      for (const update of updates) {
        const { identifier, data } = update;
        // Find the object with the matching identifier
        const objectIndex = updatedObjects.findIndex(
          (obj) => obj.identifier === identifier,
        );

        if (objectIndex !== -1) {
          // Object with matching identifier found, update the data
          updatedObjects[objectIndex].data = data;
        }
      }
      return updatedObjects;
    });
  };

  const handleMultipleDelete = (updates: TradingGridData[]) => {
    setTradingGridGroupData((prevObjects) => {
      const updatedObjects = [...prevObjects]; // Create a copy of the existing objects

      for (const update of updates) {
        const { identifier, data } = update;
        // Find the object with the matching identifier
        const objectIndex = updatedObjects.findIndex(
          (obj) => obj.identifier === identifier,
        );

        if (objectIndex !== -1) {
          // Object with matching identifier found, update the data

          const updatedMarketData = updatedObjects[objectIndex].data?.filter(
            (item: any) => !updates[0]?.data?.includes(item?.id),
          );
          if (updatedMarketData === undefined || updatedMarketData === null) {
            return updatedObjects;
          } else {
            updatedObjects[objectIndex].data = updatedMarketData;
          }
        }
      }
      return updatedObjects;
    });
  };

  const handleUpdate = (updates: TradingGridData[]) => {
    setTradingGridGroupData((prevObjects) => {
      const updatedObjects = [...prevObjects]; // Create a copy of the existing objects

      for (const update of updates) {
        const { identifier, data } = update;
        // Find the object with the matching identifier
        const objectIndex = updatedObjects.findIndex(
          (obj) => obj.identifier === identifier,
        );

        if (objectIndex !== -1) {
          // Object with matching identifier found, update the data
          const existingData = updatedObjects[objectIndex].data;

          if (updatedObjects[objectIndex].data.length <= update.data.length) {
            // existingData = updates.data;
            let existData = [...prevObjects];
            existData[objectIndex].data = update.data;
            return existData;
          }
          for (const newData of data) {
            const { id } = newData;

            // Find the data object with the matching ID
            const dataIndex = existingData.findIndex(
              (item) => item["id"] === id,
            );

            if (dataIndex !== -1) {
              // Data object with matching ID found, update the price
              existingData[dataIndex] = newData;
            }
          }
        } else {
          return [...updates, ...updatedObjects];
        }
      }
      return updatedObjects;
    });
  };

  function updateCollection3(response: any) {
    const payload = response.payload;
    console.log("updateCollection3", payload);

    // if (isEmpty(payload.data) && isEmpty(payload.deletions)) return

    // if (payload.isSnapshot) {
    //   this.setCollection(response)
    // } else {
    //   if (payload.data.length) {
    //     payload.data.forEach((order) => {
    //       const modelToUpdate = this.findWhere({
    //         id: order.id
    //       })

    //       if (modelToUpdate) {
    //         this.updateModel(modelToUpdate, order, response)
    //       } else {
    //         this.addModel(response)
    //       }
    //     })
    //   }

    //   if (payload.deletions.length) {
    //     this.deleteModels(payload.deletions)
    //   }
    // }
  }

  // sendRequest(action, type, payload)

  // handleUserDetails() {
  //     this.requestId = uuid()
  //     const requestActions = {
  //       action: this.config.SUBSCRIBE_REQUEST_ACTION,
  //       type: this.config.SUBSCRIBE_REQUEST_TYPE
  //     }
  //     const request = objectAssign({}, {
  //       requestID: this.requestId,
  //       payload: {
  //         orderId: '',
  //         ordersDataType: this.config.USERS_DATA_TYPE
  //       }
  //     }, requestActions)

  //     return Platform.socket.send(config.socket.channels.TRADING, request)
  //   }

  /**
   * Hides the modal when dispose card overlays
   * event is triggered.
   * @param  {object} response error response
   * @return undefined
   */
  function disposeModal(response: any) {
    // if (response.requestID === this.requestID || response.requestID === this.orderRequestID || response.requestID === this.orderAggRequestID) {
    //     this.set('modalVisible', false)
    // }
  }

  /**
   * Store the resturned search criteria object in the global
   * config as this dataset will not change then go ahead and
   * display the workspace.
   *
   * @param  {Object} response Server response from search criteria
   * @return {undefined}
   */
  function storeEntryCriteria(response: any) {
    console.log("CMED_ORDER_ENTRY_RESPONSE", response);
    // if (response.requestID === this.orderEntryCriteriaRequestID) {
    //     setEntryCriteria(response.payload)
    // }
  }

  function updateActiveModel(response: any) {
    console.log("CMED_ORDER_ENTRY_REQUEST ", response);
    // if ((response.action === config_mktData.socket.actions.CMED_ORDER_ENTRY && response.requestID === this.orderRequestID) ||
    //     (response.action === config_mktData.socket.actions.CMED_ORDER_AGGRESSSION && response.requestID === this.orderAggRequestID)) {
    //     this.set('responsePending', false)
    //     if (response.status === 'ERROR') {
    //         if (!isEmpty(response.warnings)) {
    //             this.set({
    //                 message: response.warnings,
    //                 ignoreWarnings: true
    //             })
    //         } else {
    //             this.set('ignoreWarnings', false)
    //             this.set('modalVisible', false)
    //             Platform.platformEvents.triggers.genericSocketError(response)
    //         }
    //     } else {
    //         this.set({
    //             ignoreWarnings: false
    //         })
    //     }
    // }
  }

  /**
   * Uses the order criteria payload to update the current model
   * with Order Type, TIF, Account values.
   *
   * @param {Object} response Server response data Object.
   */
  function setEntryCriteria(criteria: any) {
    // this.set(criteria)
    // this.set('ticksDisabled', false)
    // this.set({ orderSource: serviceConfig.orderHandlingFields })
  }

  /**
   * Concatenates the new direction ticks to the current direction list
   *
   * @param  {Object} response Updated list of UP or DOWN tick prices
   * @return {undefined}
   */
  function updateTicks(response: any) {
    console.log("CMED_PRICE_TICKS_RESPONSE ", response);
    // if (response.requestID === this.priceTicksRequestID) {
    //     const prices = this.get('prices')
    //     const pricesResponse = response.payload
    //     const tickDirection = this.get('currentTickDirection')

    //     if (tickDirection !== 'both' && !isEmpty(tickDirection)) {
    //         prices[tickDirection] = prices[tickDirection].concat(pricesResponse[tickDirection])
    //         this.set('prices', prices)
    //     } else {
    //         this.set('prices', pricesResponse)
    //     }

    //     this.set('ticksDisabled', false)
    // }
  }

  function fetchPriceTicks(options: any) {
    // this.set('ticksDisabled', true)
    // this.priceTicksRequestID = uuid()
    // return Platform.socket.send(config.socket.channels.TRADING, {
    //     action: config_mktData.socket.actions.CMED_ITEM_PRICES,
    //     requestID: this.priceTicksRequestID,
    //     type: 'cmedGetPriceTicksRequest',
    //     payload: {
    //         itemId: this.get('ii'), // a valid value taken from ITradingGridGroupItemMarketData.ii
    //         basePrice: options.basePrice, // Decimal? or does it need to be fractional sometimes? b.f or bo.f
    //         direction: options.direction // true=Up, false=Down
    //     }
    // })
  }

  function fetchOrderEntryCriteria(options: any) {
    // this.orderEntryCriteriaRequestID = uuid()
    // return Platform.socket.send(config.socket.channels.TRADING, {
    //     action: config_mktData.socket.actions.CMED_ORDER_CRITERIA,
    //     requestID: this.orderEntryCriteriaRequestID,
    //     type: 'cmedOrderEntryCriteriaRequest',
    //     payload: {
    //         basePrice: options.price, // Decimal? or does it need to be fractional sometimes?
    //         itemId: this.get('ii') // a valid value taken from ITradingGridGroupItemMarketData.ii
    //     }
    // })
  }

  /**
   * Param hash used to make order request.
   *
   * @param  {Object} params Hash of attribute values used in the order request.
   * @return {Object}
   */
  function submitOrderRequest(params: any) {
    // this.orderRequestID = uuid()
    // this.set('responsePending', true)
    // const orderRequest = {
    //     action: config_mktData.socket.actions.CMED_ORDER_ENTRY,
    //     requestID: this.orderRequestID,
    //     type: 'cmedOrderEntryRequest',
    //     payload: {
    //         orderPrice: (this.get('orderType') !== 2 || this.get('orderType') !== 4 || this.get('orderType') !== 8) ? params.orderPrice : null,
    //         orderQuantity: params.quantity,
    //         side: this.get('side') === 'Buy' ? 1 : 2,
    //         tif: params.tif,
    //         orderType: this.get('orderType'),
    //         itemId: this.get('ii'),
    //         accountId: params.accountId,
    //         stopPrice: (this.get('orderType') === 8 || this.get('orderType') === 16) ? params.stopPrice : null,
    //         expiryDate: (params.tif === 4 && !isEmpty(params.expiryDate)) ? params.expiryDateAPIFormatted : null,
    //         disclosedQuantity: (params.isIceberg === true && params.disclosedQuantity) ? params.disclosedQuantity : null,
    //         orderHandling: params.orderHandling ? params.orderHandling.toString() : '1',
    //         executingPartyIdentifier: params.executingPartyIdentifier ? params.executingPartyIdentifier.toString() : '',
    //         ignoreWarnings: this.get('ignoreWarnings')
    //     }
    // }
    // return Platform.socket.send(config.socket.channels.TRADING, orderRequest)
  }

  /**
   * Param hash used to make order aggression request.
   *
   * @param  {Object} params Hash of attribute values used in the order aggression request.
   * @return {Object}
   */

  function submitAggressionRequest(params: any) {
    // this.orderAggRequestID = uuid()
    // this.set('responsePending', true)
    // const orderRequest = {
    //     action: config_mktData.socket.actions.CMED_ORDER_AGGRESSSION,
    //     requestID: this.orderAggRequestID,
    //     type: 'cmedOrderAggressionRequest',
    //     payload: {
    //         orderPrice: (this.get('orderType') !== 2 || this.get('orderType') !== 4 || this.get('orderType') !== 8) ? params.orderPrice : null,
    //         orderQuantity: params.quantity,
    //         side: this.get('side') === 'Buy' ? 1 : 2,
    //         tif: params.tif,
    //         itemId: this.get('ii'),
    //         accountId: params.accountId,
    //         orderHandling: params.orderHandling ? params.orderHandling.toString() : 1,
    //         executingPartyIdentifier: params.executingPartyIdentifier ? params.executingPartyIdentifier.toString() : '',
    //         ignoreWarnings: this.get('ignoreWarnings')
    //     }
    // }
    // return Platform.socket.send(config.socket.channels.TRADING, orderRequest)
  }

  function onOrderSuccess(response: any) {
    console.log("CMED_NEW_ORDER_SUCCESS ", response);
    // if (response.requestID === this.orderRequestID) {
    //     this.set({
    //         responsePending: false,
    //         newOrderSuccess: true,
    //         orderId: response.payload.orderId
    //     })
    // }
  }

  function onAggressionOrderSuccess(response: any) {
    console.log("CMED_AGGRESSION_ORDER_SUCCESS ", response);
    // if (response.requestID === this.orderAggRequestID) {
    //     this.set({
    //         responsePending: false,
    //         aggressionOrderSuccess: true,
    //         orderId: response.payload.orderId
    //     })
    // }
  }

  function onContractRemoved(response: any) {
    console.log("CMED_CONTRACT_REMOVED_SUCCESS ", response);
    // if (response.requestID === this.requestID) {
    //     this.set({
    //         removalPending: false,
    //         removeSuccess: true
    //     })
    // }
  }

  function removeContractFromGrid(id: any, groupId: any) {
    // this.set({
    //     removalPending: true
    // })
    // this.requestID = uuid()
    // let requestActions = {
    //     action: config.socket.actions.CMED_REMOVE_CONTRACTS,
    //     requestID: this.requestID,
    //     type: 'notUsedButMustBePresentForLegacyValidation',
    //     payload: {
    //         itemId: id,
    //         groupId
    //     }
    // }
    // return Platform.socket.send(config.socket.channels.TRADING, requestActions)
  }

  /**
   * Clone the object reference so we aren't directly changing the referenced object
   * which would cause problems during multiple parsing.
   *
   * Level 1 structure
   *  {
   *  	b 	{f: '2', r: 2}
   *		bb 	{f: '40.19', r: 40.19}
   *		bo 	{f: '', r: 0}
   *		boq {f: '', r: 0}
   *	}
   *
   * @param  {Object}
   * @return {Object} Modified attribute hash.
   */
  function parse(response: any) {
    // const model = clone(response)
    // switch (model.lt) {
    //     case '?':
    //     case 0:
    //         model.lt = '?'
    //         break
    //     case 'Plus':
    //     case 1:
    //         model.lt = 'Plus'
    //         break
    //     case 'PlusOnLastChange':
    //     case 2:
    //         model.lt = 'PlusOnLastChange'
    //         break
    //     case 'Minus':
    //     case 3:
    //         model.lt = 'Minus'
    //         break
    //     case 'MinusOnLastChange':
    //     case 4:
    //         model.lt = 'MinusOnLastChange'
    //         break
    //     default:
    //         model.lt = ''
    //         break
    // }
    // if (!model.hasOwnProperty('n') || isNull(model.n)) { model.n = { f: '', r: 0 } }
    // if (model.hasOwnProperty('n') && (model.n.r !== 0 && model.n.f !== '' && !startsWith(model.n.f, '-')) && !startsWith(model.n.f, '+')) {
    //     model.n.f = `+${response.n.f}`
    // }
    // // UI for price change
    // if (startsWith(model.n.f, '-')) {
    //     model.priceChange = 'negative'
    // } else if (startsWith(model.n.f, '+')) {
    //     model.priceChange = 'positive'
    // } else {
    //     model.priceChange = 'unchanged'
    // }
    // if (model.bb === null) { model.bb = {} }
    // if (model.b === null) { model.b = {} }
    // if (model.boq === null) { model.boq = {} }
    // if (model.bo === null) { model.bo = {} }
    // if (model.bb.r === 0 && model.b.r === 0) {
    //     model.b.f = model.bb.f = ''
    // }
    // if (model.bo.r === 0 && model.boq.r === 0) {
    //     model.bo.f = model.boq.f = ''
    // }
    // return model
  }

  return (
    <MarketDataContainer
      userCMEDEntitlements={props.userCMEDEntitlements}
      setIsSnapshot={setIsSnapshot}
      tradingGridGroup={tradingGridGroup}
      setTradingGridGroup={setTradingGridGroup}
      tradingGridGroupData={tradingGridGroupData}
      tradingGridGroupLiveView={tradingGridGroupLiveView}
      setTradingGridGroupLiveView={setTradingGridGroupLiveView}
      isCMEDLoggedIn={props.isCMEDLoggedIn}
      setSendRequest={props.setSendRequest}
      sendRequest={props.sendRequest}
      isSnapshot={isSnapshot}
      currentSelectedProfile={props.currentSelectedProfile}
      isLoadingMarketData={isLoadingMarketData}
      setIsLoadingMarketData={setIsLoadingMarketData}
    />
  );
}

export default MarketDataContent;
